// JavaScript to Handle Share Button Clicks
document.addEventListener('DOMContentLoaded', function () {
    const shareButtons = document.querySelectorAll('.share-btn');

    shareButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const network = this.getAttribute('data-network');
            shareArticle(network);
        });
    });
});

function shareArticle(network) {
    const url = document.location.href; // URL of the current page to share
    let shareUrl = '';

    switch (network) {
        case 'facebook':
            shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
            break;
        case 'linkedin':
            shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}`;
            break;
        default:
            console.error('Unsupported network');
            return;
    }

    // Open the share dialog in a new window
    window.open(shareUrl, 'ShareDialog', 'width=626,height=436');
}
